/** Protected and system comments are the submission's record: nobody edits or deletes them. */
export function isSubmissionRecordComment(comment: {
  isProtected?: boolean | null;
  isSystemMessage?: boolean | null;
}): boolean {
  return Boolean(comment.isProtected || comment.isSystemMessage);
}
